import api, { handleAPIErrors } from 'shared/api'

const FETCH_REQUEST = 'executiveChange/FETCH_REQUEST';
const FETCH_SUCCESS = 'executiveChange/FETCH_SUCCESS';
const FETCH_FAILURE = 'executiveChange/FETCH_FAILURE';
const FETCH_FILTER_REQUEST = 'executiveChange/FETCH_FILTER_REQUEST'
const FETCH_FILTER_SUCCESS = 'executiveChange/FETCH_FILTER_SUCCESS'
const FETCH_FILTER_FAILURE = 'executiveChange/FETCH_FILTER_FAILURE'
const FETCH_ALL_REQUEST = 'executiveChange/FETCH_ALL_REQUEST'
const FETCH_ALL_SUCCESS = 'executiveChange/FETCH_ALL_SUCCESS'
const FETCH_ALL_FAILURE = 'executiveChange/FETCH_ALL_FAILURE'

const initialState = {
    result: {total: 0, data: []},
    loaded: false,
    loading: false,
    allResult: {total: 0, data: []},
    allLoaded: false,
    allLoading: false,
    filterLoaded: false,
    filterLoading: false,
    errors: []
};

export function fetchRequest(payload = {}){
    return {
        type: FETCH_REQUEST
    }
}

export function fetchSuccess(payload){
    return {
        type: FETCH_SUCCESS,
        payload
    }
}

export function fetchFailure(errors = []){
    return {
        type: FETCH_FAILURE,
        errors
    }
}

export function fetchFilterRequest(payload = {}){
    return {
        type: FETCH_FILTER_REQUEST
    }
}

export function fetchFilterSuccess(payload){
    return {
        type: FETCH_FILTER_SUCCESS,
        payload
    }
}

export function fetchFilterFailure(errors = []){
    return {
        type: FETCH_FILTER_FAILURE,
        errors
    }
}

export function fetchAllRequest(payload = {}){
    return {
        type: FETCH_ALL_REQUEST
    }
}

export function fetchAllSuccess(payload){
    return {
        type: FETCH_ALL_SUCCESS,
        payload
    }
}

export function fetchAllFailure(errors = []){
    return {
        type: FETCH_ALL_FAILURE,
        errors
    }
}

export function loadData(options) {
    return (dispatch) => {
        dispatch(fetchRequest());

        return api('api/v1/executive_changes/', options, {}, true)
            .then(response => response.json().then(json => ({ json, response })))
            .then(({ json, response }) => {
                if (!response.ok) {
                    return Promise.reject(json)
                }

                dispatch(fetchSuccess(json))
            })
            .catch((exception) => {
                handleAPIErrors(exception, (errors) => {
                    dispatch(fetchFailure(errors))
                })
            });
    }
}

export function loadFilterData(options) {
    return (dispatch) => {
        dispatch(fetchFilterRequest());

        return api('api/v1/executive_changes/', options, {}, true)
          .then(response => response.json().then(json => ({ json, response })))
          .then(({ json, response }) => {
              if (!response.ok) {
                  return Promise.reject(json)
              }

              dispatch(fetchFilterSuccess(json))
          })
          .catch((exception) => {
            handleAPIErrors(exception, (errors) => {
                dispatch(fetchFilterFailure(errors))
            })
          });
    }
}

export function loadAllData(options = {}) {
    return (dispatch) => {
        dispatch(fetchAllRequest());

        return api('api/v1/executive_changes/', options, {}, true)
          .then(response => response.json().then(json => ({ json, response })))
          .then(({ json, response }) => {
              if (!response.ok) {
                  return Promise.reject(json)
              }

              dispatch(fetchAllSuccess(json))
          })
          .catch((exception) => {
            handleAPIErrors(exception, (errors) => {
                dispatch(fetchAllFailure(errors))
            })
          });
    }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
    const { payload, type, errors } = action;

    switch (type) {
        case FETCH_REQUEST:
            return Object.assign({}, state, {
                loading: true
            });
        case FETCH_SUCCESS:
            return Object.assign({}, state, {
                loading: false,
                loaded: true,
                errors: [],
                result: payload
            });
        case FETCH_FAILURE:
            return Object.assign({}, state, {
                loaded: false,
                loading: false,
                errors
            });
        case FETCH_FILTER_REQUEST:
            return Object.assign({}, state, {
                filterLoading: true
            });
        case FETCH_FILTER_SUCCESS:
            return Object.assign({}, state, {
                filterLoading: false,
                filterLoaded: true,
                errors: [],
                result: payload
            });
        case FETCH_FILTER_FAILURE:
            return Object.assign({}, state, {
                filterLoaded: false,
                filterLoading: false,
                errors
            });
        case FETCH_ALL_REQUEST:
            return Object.assign({}, state, {
                allLoading: true
            });
        case FETCH_ALL_SUCCESS:
            return Object.assign({}, state, {
                allLoading: false,
                allLoaded: true,
                errors: [],
                allResult: payload
            });
        case FETCH_ALL_FAILURE:
            return Object.assign({}, state, {
                allLoaded: false,
                allLoading: false,
                errors
            });
        default:
            return state
    }
}
